export const KEYTYPE = {
  ENTER: 'ENTER',
};
